/**
 * Created by jv on 2019-10-01 (16:40).
 */
const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import CONSTANTS from "Sources/config/constants";
import LanguageManager from "Sources/services/language-manager";

require("Styles/components/score-screen.scss");

let TEST_MODE = __DEVELOPMENT__ && false;

class ScoreScreen {
  constructor(options) {
    this.id = utils.generateElementId("score-screen-");

    this.$container = $(options.container);

    this.title = options.title;

    this.mode = options.mode ? options.mode : "business-model";
    this.isFinal = options.isFinal;

    this.team = options.team;
    this.teams = options.teams;

    if (TEST_MODE) this.teams = ["Team1", "Team2", "Team3", "Team4", "Team5", "Team6", "Team7 op 2 lijnen", "Team8", "Team9", "Team10"];

    this.roundOverview = options.roundOverview;
    this.roundIndex = options.roundIndex;

    this.hideAnimationTimeout = null;

    this._stacked = false;

    this._interactive = options.interactive;
    this.callbackContext = options.callbackContext;
    this.onTeamScoreClick = options.onTeamScoreClick;
  }

  get roundOverview() {
    return this._roundOverview;
  }

  set roundOverview(roundOverview) {
    this._roundOverview = roundOverview;
    if (TEST_MODE) tmpDuplicateTeamData.call(this);
  }

  get title() {
    return this._title;
  }

  set title(title) {
    this._title = title;

    if (utils.isNotNull(this.$element) && this.$element.length) {
      let $title = this.$element.find(".scs__title");

      if (utils.isNotNull(this.title)) {
        $title.text(this.title).show();
      } else {
        $title.hide();
      }
    }
  }

  get interactive() {
    return this._interactive;
  }

  set interactive(interactive) {
    this._interactive = interactive;

    if (utils.isNotNull(this.$element) && this.$element.length) {
      if (this.interactive) {
        this.$element.addClass("scs__interactive");
      } else {
        this.$element.removeClass("scs__interactive");
      }
    }
  }

  get mode() {
    return this._mode;
  }

  set mode(mode) {
    this._mode = mode;
    if (utils.isNotNull(this.$element) && this.$element.length) {
      this.$element.removeClass((index, className) => {
        return (className.match(/(^|\s)scs-mode__\S+/g) || []).join(" ");
      });
      this.$element.addClass(`scs-mode__${this.mode}`);
    }
  }

  get stacked() {
    return this._stacked;
  }

  set stacked(stacked) {
    if (this.stacked !== stacked) {
      this._stacked = stacked;

      if (this.stacked) this.$element.addClass("scs__stacked");
      else this.$element.removeClass("scs__stacked");

      this.update();
    }
  }

  showWaitingIndicators() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      this.$element.removeClass("scs__waiting-disabled");
    }
  }

  hideWaitingIndicators() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      this.$element.addClass("scs__waiting-disabled");
    }
  }

  updateTeamList(teamList) {
    this.teams = teamList;

    if (this.hasRendered) {
      this.render();
      this.update();
    }
  }

  render() {
    if (utils.isNotNull(this.$element) && this.$element.length) this.destroy();

    this.hasRendered = false;

    this.$element = $("<div class='score-screen'></div>");
    this.$element.addClass(`scs-mode__${this.mode}`);

    if (this.interactive) {
      this.$element.addClass("scs__interactive");
    }

    if (this.teams.length > 8) {
      this.$element.addClass("scs__small");
    }

    if (this.stacked) {
      this.$element.addClass("scs__stacked");
    }

    let $title = $("<h4 class='scs__title'></h4>");

    if (utils.isNotNull(this.title)) {
      $title.text(this.title);
    } else {
      $title.hide();
    }

    this.$element.append($title);

    let $teamsWrapper = $("<div class='score-screen__teams'></div>");

    let $teamScoresWrapper = $("<div class='scs__team-scores'></div>");
    let $teamLabelsWrapper = $("<div class='scs__team-labels'></div>");

    // Sort teams by name
    this.teams.sort((t1, t2) => t1.localeCompare(t2));

    for (let i = 0; i < this.teams.length; i++) {
      let team = this.teams[i];

      let $scoreEntry = $("<div class='score-screen__team-score'></div>");
      $scoreEntry.attr("data-team-name", team);

      if (utils.isNotNull(this.team) && this.team.name === team) {
        $scoreEntry.addClass("scs__active");
      }

      let $scoreBarWrapper = $("<div class='score-screen__bar-wrapper'></div>");
      let $scoreBar = $("<div class='score-screen__bar'></div>");
      $scoreBar.append("<div class='score-data score-data__points'>0</div>");
      $scoreBar.append("<div class='score-data score-data__budget'>0</div>");
      $scoreBar.append("<div class='score-data score-data__has-loaned' style='display: none;'></div>");

      $scoreBarWrapper.append("<div class='score-screen__position'></div>");
      $scoreBarWrapper.append($scoreBar);
      $scoreEntry.append($scoreBarWrapper);

      let $teamLabel = $("<div class='score-screen__team-label'></div>");
      $teamLabel.attr("data-team-name", team);

      if (utils.isNotNull(this.team) && this.team.name === team) {
        $teamLabel.addClass("scs__active");
      }

      $teamLabel.append(`<div class='score-screen__team-name'>${team}</div>`);

      $teamLabel.append(`<div class="score-screen__waiting-indicator">${LanguageManager.getValueForKey("serious_game.business_model.score_screen.waiting.indicator")}</div>`);

      let $quizResult = $("<div class='score-screen__quiz-result'></div>");
      if (this.mode !== "quiz") $quizResult.hide();
      $teamLabel.append($quizResult);

      $teamLabel.append(`<button class="btn btn-link scs-team-interact-btn" type="button">${LanguageManager.getValueForKey("serious_game.business_model.score_screen.interact_btn")}</button>`);

      $teamScoresWrapper.append($scoreEntry);
      $teamLabelsWrapper.append($teamLabel);
    }

    $teamsWrapper.append($teamScoresWrapper);
    $teamsWrapper.append($teamLabelsWrapper);

    this.$element.append($teamsWrapper);

    this.$container.append(this.$element);

    this.setUpEventListeners();

    this.hasRendered = true;
  }

  show(darkMode) {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      if (utils.isNotNull(this.hideAnimationTimeout)) {
        clearTimeout(this.hideAnimationTimeout);
        this.hideAnimationTimeout = null;
      }

      if (utils.isNotNull(this.elementObserver)) {
        this.elementObserver.observe(this.$element.get(0), {attributes: true, childList: false, subtree: false});
      }

      if (darkMode) this.$element.addClass("scs__dark-mode");
      else this.$element.removeClass("scs__dark-mode");

      this.$element.addClass("scs__visible");
      this.$container.show();
      this.update();

      if (TEST_MODE) tmpDoTest.call(this);
    }
  }

  hide() {
    if (utils.isNotNull(this.$container) && this.$container.length) {
      if (utils.isNotNull(this.hideAnimationTimeout)) {
        clearTimeout(this.hideAnimationTimeout);
        this.hideAnimationTimeout = null;
      }

      if (utils.isNotNull(this.elementObserver)) {
        this.elementObserver.disconnect();
      }

      this.$element.removeClass("scs__visible");

      this.hideAnimationTimeout = setTimeout(() => {
        this.hideAnimationTimeout = null;
        this.$container.hide();
      }, CONSTANTS.BM_TRANSITION_SPEED);
    }
  }

  isOpen() {
    return utils.isNotNull(this.$element) && this.$element.length && this.$element.hasClass("scs__visible");
  }

  update() {
    let that = this;
    this.$element.find(".score-screen__team-score").removeClass("scs__active scs__waiting");
    this.$element.find(".score-screen__team-label").removeClass("scs__active scs__waiting");

    let scoreInfo = this.getScoreInfo();

    if (utils.isNotNull(scoreInfo)) {
      for (let i = 0; i < this.teams.length; i++) {
        let $scoreEntry = this.$element.find(`.score-screen__team-score[data-team-name='${this.teams[i]}']`);
        let $teamLabel = this.$element.find(`.score-screen__team-label[data-team-name='${this.teams[i]}']`);

        that.updateTeamScore($scoreEntry, $teamLabel, scoreInfo);
      }
    }
  }

  updateTeamScore($scoreEntry, $teamLabel, scoreInfo) {
    let teamName = $scoreEntry.data("team-name") + "";
    let teamData = this.getCommonDataForTeam(teamName);

    if (utils.isNotNull(teamData)) {
      let hasClosedRound = utils.isNotNull(teamData.state.currentRoundClosed) || this.roundIndex < teamData.state.currentRound;
      let roundScore = this.getCurrentRoundScore(teamData);

      if ((this.mode === "quiz" && utils.isNull(teamData.quizResult)) || utils.isNull(roundScore)) {
        log.error("Invalid score data for team [%s] - %o", teamData.teamName, teamData);
        return;
      }

      if (utils.isNotNull(this.team) && this.team.name === teamName) {
        $scoreEntry.addClass("scs__active");
        $teamLabel.addClass("scs__active");
      }

      $scoreEntry.data("closed-round", hasClosedRound);
      $teamLabel.data("closed-round", hasClosedRound);

      if (!hasClosedRound) {
        $scoreEntry.addClass("scs__waiting");
        $teamLabel.addClass("scs__waiting");
      }

      let $barWrapper = $scoreEntry.find(".score-screen__bar-wrapper");
      let $position = $scoreEntry.find(".score-screen__position");

      let $bar = $scoreEntry.find(".score-screen__bar");
      let $points = $bar.find(".score-data__points");
      let $budget = $bar.find(".score-data__budget");
      let $hasLoaned = $bar.find(".score-data__has-loaned");

      let $quizScore = $teamLabel.find(".score-screen__quiz-result");

      $hasLoaned.hide();

      if (this.mode === "quiz") {
        $position.text(`#${scoreInfo.teamPositions[teamName]}`).hide();
        $points.hide();
        $budget.text(teamData.quizResult.startBudget).show();
        $quizScore.text(`${teamData.quizResult.quizScore}/${scoreInfo.highestScore}`).show();

        if (this.stacked) {
          let width = ScoreScreen.getBarWidth($barWrapper, $bar, $position, teamData.quizResult.quizScore, scoreInfo.lowestScore, scoreInfo.highestScore);
          $bar.css("width", width);
        } else {
          let height = ScoreScreen.getBarHeight($barWrapper, $bar, $position, teamData.quizResult.quizScore, scoreInfo.lowestScore, scoreInfo.highestScore);
          $bar.css("height", height);
        }
      } else {
        $position.text(`#${scoreInfo.teamPositions[teamName]}`).show();

        if (this.isFinal) {
          $points.text(roundScore.totalScore).show();
          $budget.text(roundScore.endBudget - roundScore.convertedBudget).show();
        } else {
          $points.text(roundScore.endPoints).show();
          $budget.text(roundScore.endBudget).show();
        }

        $quizScore.hide();

        if (teamData.totalLoaned > 0) {
          $hasLoaned.show();
        }

        if (this.stacked) {
          let width = ScoreScreen.getBarWidth($barWrapper, $bar, $position, roundScore.totalScore, scoreInfo.lowestScore, scoreInfo.highestScore);
          $bar.css("width", width);
        } else {
          let height = ScoreScreen.getBarHeight($barWrapper, $bar, $position, roundScore.totalScore, scoreInfo.lowestScore, scoreInfo.highestScore);
          $bar.css("height", height);
        }
      }
    } else {
      log.error("Unable to find teamData for team [%s]", teamName);
    }
  }

  static getBarHeight($barWrapper, $bar, $position, totalScore, lowestScore, highestScore) {
    let minBarHeight = utils.parseFloat($bar.css("minHeight"));
    minBarHeight = utils.isNotNull(minBarHeight) ? minBarHeight : 0;
    let maxBarHeight = $barWrapper.height() - $position.outerHeight(true) - minBarHeight;

    // Normalized to [0-1]
    let heightPercentage = (totalScore - lowestScore) / (highestScore - lowestScore);
    let barHeight = (maxBarHeight * heightPercentage) + minBarHeight;

    // log.info("Calculating bar height\nMax height: %f\nMin bar height: %f\nPercentage: %f/%f (%f%) --> %fpx", maxBarHeight, minBarHeight, totalScore, highestScore, Math.round(heightPercentage * 10000) / 100, barHeight);

    return barHeight;
  }

  static getBarWidth($barWrapper, $bar, $position, totalScore, lowestScore, highestScore) {
    let minBarWidth = utils.parseFloat($bar.css("minWidth"));
    minBarWidth = utils.isNotNull(minBarWidth) ? minBarWidth : 0;
    let maxBarWidth = $barWrapper.width() - $position.outerWidth(true) - minBarWidth;

    // Normalized to [0-1]
    let widthPercentage = (totalScore - lowestScore) / (highestScore - lowestScore);
    let barWidth = (maxBarWidth * widthPercentage) + minBarWidth;

    // log.info("Calculating bar height\nMax height: %f\nMin bar height: %f\nPercentage: %f/%f (%f%) --> %fpx", maxBarHeight, minBarHeight, totalScore, highestScore, Math.round(heightPercentage * 10000) / 100, barHeight);

    return barWidth;
  }

  getCommonDataForTeam(teamName) {
    if (utils.isNull(this.roundOverview) || utils.isNull(this.roundOverview.commonTeamData)) return null;

    for (let i = 0; i < this.roundOverview.commonTeamData.length; i++) {
      let teamData = this.roundOverview.commonTeamData[i];

      if (teamData.teamName === teamName) {
        return teamData;
      }
    }

    return null;
  }

  getCurrentRoundScore(teamData) {
    if (utils.isNull(teamData) || utils.isNull(teamData.roundScores)) return null;

    let roundScore = null;

    for (let j = teamData.roundScores.length - 1; j >= 0; j--) {
      if ((utils.isNull(this.roundIndex) || teamData.roundScores[j].round === this.roundIndex) && teamData.state.currentRound >= teamData.roundScores[j].round) {
        roundScore = teamData.roundScores[j];
        break;
      }
    }

    return roundScore;
  }

  getScoreInfo() {
    if (utils.isNull(this.roundOverview) || utils.isNull(this.roundOverview.commonTeamData)) return null;

    let lowestScore = null;
    let highestScore = 0;

    let scores = [];

    let positionMap = {};
    let teamPositions = {};
    let allTeamsFinished = true;

    for (let i = 0; i < this.roundOverview.commonTeamData.length; i++) {
      let teamData = this.roundOverview.commonTeamData[i];
      let roundScore = this.getCurrentRoundScore(teamData);

      if (utils.isNull(teamData.state.currentRoundClosed)) {
        allTeamsFinished = false;
      }

      if (utils.isNotNull(roundScore)) {
        // If quiz --> use # questions answered correctly instead of points score
        let teamScore = this.mode === "quiz" ? teamData.quizResult.quizScore : roundScore.totalScore;
        let score = scores.find(s => s.score === teamScore);

        if (utils.isNull(score)) {
          score = {
            score: teamScore,
            teams: []
          };

          scores.push(score);
        }

        score.teams.push(teamData.teamName);
      }
    }

    // Sort scores descending
    scores.sort((s1, s2) => s2.score - s1.score);

    let currentPosition = 1;

    for (let i = 0; i < scores.length; i++) {
      if (scores[i].score > highestScore) {
        highestScore = scores[i].score;
      } else if (utils.isNull(lowestScore) || scores[i].score < lowestScore) {
        lowestScore = scores[i].score;
      }

      if (i > 0) currentPosition += scores[i - 1].teams.length;
      positionMap[currentPosition] = scores[i].teams;

      for (let j = 0; j < scores[i].teams.length; j++) {
        if (!teamPositions.hasOwnProperty(scores[i].teams[j])) {
          teamPositions[scores[i].teams[j]] = currentPosition;
        }
      }
    }

    let scoreInfo = {
      positionMap,
      teamPositions,
      highestScore: this.mode === "quiz" ? 5 : highestScore,
      lowestScore: this.mode === "quiz" ? 0 : lowestScore,
      allTeamsFinished
    };

    log.debug("Score info - %o", scoreInfo);

    return scoreInfo;
  }

  destroy() {
    this.$element.remove();
  }

  setUpEventListeners() {
    this.$element.find(".scs-team-interact-btn").off("click").on("click", (e) => {
      if (this.interactive) {
        let $this = $(e.delegateTarget);
        let $teamScore = $this.closest(".score-screen__team-label");

        let teamName = $teamScore.data("team-name");
        let closedRound = $teamScore.data("closed-round");

        teamName = utils.isNotNull(teamName) ? teamName + "" : teamName;

        if (closedRound) {
          if (utils.isFunction(this.onTeamScoreClick)) {
            this.onTeamScoreClick.call(this.callbackContext, e, teamName);
          }
        }
      }
    });

    let onResize = utils.debounce(this.reflow.bind(this), 250, false, this);
    window.addEventListener("resize", onResize, false);

    if (utils.isNotNull(window.MutationObserver)) {
      this.elementObserver = new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
          if (mutation.type === "attributes" && mutation.attributeName === "class") {
            this.stacked = this.$element.hasClass("scs__stacked");
          }
        }
      });
    }
  }

  reflow() {
    this.$element.find(".score-screen__bar").each((index, el) => {
      $(el).css("width", "");
      $(el).css("height", "");
    });

    this.update();
  }
}


let tmpDuplicateTeamData;
let tmpDoTest;

if (__DEVELOPMENT__) {
  tmpDuplicateTeamData = function () {
    if (utils.isNull(this.roundOverview)) return;

    for (let i = 1; i < this.teams.length; i++) {
      let exists = false;

      for (let j = 0; j < this.roundOverview.commonTeamData.length; j++) {
        if (this.roundOverview.commonTeamData[j].teamName === this.teams[i]) {
          exists = true;
          break;
        }
      }

      if (exists) continue;

      let tmp = JSON.parse(JSON.stringify(this.roundOverview.commonTeamData[0]));
      tmp.teamName = this.teams[i];

      let rs = tmp.roundScores[tmp.roundScores.length - 2];
      rs.endPoints = utils.getRandomIntInclusive(4, 12);
      rs.endBudget += utils.getRandomIntInclusive(-2, 6);

      tmp.roundScores.pop();

      rs.totalScore = rs.endPoints + (rs.endBudget > 0 ? Math.floor(rs.endBudget) : 0);

      tmp.state.currentRoundClosed = null;

      this.roundOverview.commonTeamData.push(tmp);
    }
  };

  tmpDoTest = function () {
    if (utils.isNull(this.roundOverview)) return;

    for (let i = 2; i < this.roundOverview.commonTeamData.length; i++) {
      setTimeout(() => {
        let teamData = this.roundOverview.commonTeamData[i];
        teamData.state.currentRoundClosed = "2019-10-04T08:02:11.000+0000";
        let rs = JSON.parse(JSON.stringify(teamData.roundScores[teamData.roundScores.length - 1]));

        rs.round += 1;
        rs.endPoints += utils.getRandomIntInclusive(2, 6);
        rs.endBudget += utils.getRandomIntInclusive(-3, 3);
        rs.totalScore = rs.endPoints + (rs.endBudget > 0 ? Math.floor(rs.endBudget / 3) : 0);

        teamData.roundScores.push(rs);

        teamData.totalLoaned = utils.getRandomIntInclusive(0, 10) > 7 ? utils.getRandomIntInclusive(1, 5) : 0;

        this.update();
      }, utils.getRandomIntInclusive(2500, 3000) * i);
    }
  };
}

export default ScoreScreen;



// WEBPACK FOOTER //
// ./app/js/components/game/components/score-screen.js